import React, { Component } from 'react';
import PanelView from '../model/PanelView.js';
import moment from 'moment';
import { CCOButton } from '../util/Components.js';
import {clone, formatVerse} from '../util/Utility.js';
import CopyToClipboard from 'react-copy-to-clipboard';

export default class SermonPanelView extends Component {

  constructor(props) {
    super(props);

    this.defaultState = {
      object: null,
      copied: null
    };

    this.state = {
      object: clone(props.objectPass),
      copied: false
    }

  }

  componentWillReceiveProps(newProps) {
    if (newProps != this.props) {
      this.state = clone(this.defaultState);
      this.setState({object: clone(newProps.objectPass)});
    }
  }

  open() {
    window.open("https://vimeo.com/" + this.state.object.vimeoID, '_blank');
  }

  render() {

    var object = this.state.object;

    //console.log(window.sermon_collections);

    var referencedString = object.otherVerses ? object.otherVerses.toCSV(formatVerse) : '';

    return (
      <PanelView type="sermon" edit delete setState={this.setState.bind(this)} object={object} {...this.props}>
        <center>
          <h2 style={{margin: 0}}>{object.title}</h2>
          <p className="popoverTextHeader">{moment.unix(parseInt(object.date)).format("MMMM Do, YYYY")}</p>
        </center>
        <div style={{height: 7}} />
        {object.mainVerse && <p>{formatVerse(object.mainVerse)}</p>}
        {object.collection !== undefined && object.collection !== "none" && window.sermon_collections[object.collection] && <p>Collection: {window.sermon_collections[object.collection].name}</p>}
        <p>Taught by {object.teacher}</p>
        {referencedString !== '' ? <p>Referenced {referencedString}</p> : null}
        {!object.blogURL && <p style={{color: 'red'}}>Needs Blog URL</p>}
        {object.shareURL && <p>Share URL: <a href={object.shareURL}>{object.shareURL}</a></p>}
        <div style={{width: 200}}>
          {object.shareURL && <CopyToClipboard text={object.shareURL} onCopy={() => this.setState({copied: object.key})}><CCOButton text={object.key !== this.state.copied ? "Copy Share URL to Clipboard" : "URL Copied"} type="primary" /></CopyToClipboard>}
          <div style={{height: 10}} />
        </div>
      </PanelView>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/sermons/SermonPanelView.js
 **/